import React, { Component } from 'react';
import { Input } from 'react-materialize';

import EventUtils from '../../utils/EventUtils';
import ObjectUtils from '../../utils/ObjectUtils';

class TableGrid extends Component {
    constructor(props) {
        super(props);
        this._handleScroll = this._handleScroll.bind(this);
    }
    
    _handleScroll(event) {
        let grid = document.querySelector('.table-grid');
        if (event.deltaY && event.deltaY < 0) {
            return;
        }
        
        if (Math.trunc(grid.scrollHeight - grid.clientHeight - grid.scrollTop) !== 0) {
            return;
        }
    
        EventUtils.raiseEvent('scroll-bottom', null, this.props);
    }

    render() {
        const { columns, entries, selected, hidden } = this.props;
        
        return (
            <div className="table-grid" hidden={ hidden || entries.length === 0 } onScroll={ this._handleScroll } onWheel={ this._handleScroll }>
                <table className="table table-bordered">
                    <thead>
                    <tr>
                        <th colSpan="1"></th>
                        { columns.map((column,id) => column.displayName ? <th key={id}>{ column.displayName }</th> : <th key={id} colSpan="1" />) }
                    </tr>
                    </thead>
                    <tbody>
                        { 
                        entries
                            .map((entry, index) => {
                            return (
                                <tr key={index} className={ selected.includes(index) ? 'selected' : '' }>
                                    <td key={index}>
                                        <Input 
                                            type="checkbox" 
                                            checked={ selected.includes(index) }
                                            onChange={ (event) => EventUtils.raiseEvent('select', { id: index, selected: event.target.checked }, this.props) }
                                            label=" " />
                                    </td>
                                    { 
                                        columns.map((column,id) => {
                                        let cellValue = ObjectUtils.getPropertyByString(entry, column.propertyName);

                                        if (column.formatter) {
                                            return (<td key={id}>{ column.formatter(cellValue, entry) }</td>);
                                        } else {
                                            return (<td key={id}>{ cellValue }</td>);
                                        }
                                        }) 
                                    }
                                </tr>
                            );
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default TableGrid;